import { render, staticRenderFns } from "./BaseDashboard.vue?vue&type=template&id=5ba86fa9&"
import script from "./BaseDashboard.vue?vue&type=script&lang=js&"
export * from "./BaseDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BaseDashboard.vue"
export default component.exports